import { forwardRef, useState } from "react";
import {
    Box,
    Dialog,
    Divider,
    Slide
} from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ReactComponent as QuestionIcon } from '../assets/question.svg';
import { Swiper, SwiperSlide, FreeMode } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

SwiperCore.use([Pagination])

function HomeHelpCash() {
    const [open, setOpen] = useState(false);
    const openClick = () => {
        setOpen(true);
    };
    const closeClick = () => {
        setOpen(false);
    };
    return (
        <>
            <Dialog fullScreen open={open} onClose={closeClick} TransitionComponent={Transition}>
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <img src='/img/back_button_black.png' onClick={closeClick} />
                    <Box
                        sx={{
                            margin: '25px 0 0 10px',
                            fontSize: '22px'
                        }}>
                        캐시 안내
                    </Box>
                </Box>
                <Divider />

                <Swiper
                    // slidesOffsetBefore={24}
                    // slidesOffsetAfter={24}
                    grabCursor={true}
                    slidesPerView={1}
                    className="mySwiper"
                    pagination={{ clickable: true }}
                    style={{
                        width: '100%',
                        height: '100%',
                        zIndex: '1',
                        '.swiper-pagination-bullets' : {
                            bottom: 0
                        }
                    }}
                >
                    <SwiperSlide>

                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '20px',
                                padding: '20px',
                                borderRadius: '5px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    캐시는 다양한 방법으로 얻을 수 있습니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/use_cash.png'
                                style={{
                                    width: '100%',
                                }} />
                        </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '20px',
                                // marginBottom: '0',
                                padding: '20px',
                                borderRadius: '5px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    쿠폰 구매 시 캐시로 할인을 받을 수 있으며, 전액으로만 사용 가능합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/use_cash_02.png'
                                style={{
                                    width: '100%'
                                }} />
                        </Box>
                    </SwiperSlide>
                </Swiper>

            </Dialog>

            <QuestionIcon
                style={{
                    width: '16px',
                    height: '16px',
                    position: 'absolute',
                    top: '0',
                    right: '12px',
                }}
                onClick={openClick} />
        </>
    )
}

export default HomeHelpCash;